"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MetaDataKey_1 = require("./MetaDataKey");

exports.metadataKey = MetaDataKey_1.metadataKey;

var PrimitiveTypeEnum_1 = require("./PrimitiveTypeEnum");

var PropertyLevel_1 = require("./PropertyLevel");

var PropertyTypeDefinition =
/** @class */
function () {
  function PropertyTypeDefinition(type, options, propertyKey, rename) {
    this.type = type;
    this.options = options;
    this.propertyKey = propertyKey;
    this.rename = rename;
  }

  PropertyTypeDefinition.fromObject = function (instanceOrClass, key) {
    return Reflect.getMetadata(MetaDataKey_1.metadataKey, instanceOrClass, key);
  };

  PropertyTypeDefinition.prototype.hasMultiple = function () {
    return (this.options & PropertyLevel_1.PropertyTypeOptions.Multiple) > 0;
  };

  PropertyTypeDefinition.prototype.noSerialization = function () {
    return (this.options & PropertyLevel_1.PropertyTypeOptions.NoSerialization) > 0;
  };

  PropertyTypeDefinition.prototype.isLazy = function () {
    return (this.options & PropertyLevel_1.PropertyTypeOptions.Lazy) > 0;
  };

  PropertyTypeDefinition.prototype.isPrimitive = function () {
    return PrimitiveTypeEnum_1.isPrimitiveTypeEnum(this.type);
  };

  return PropertyTypeDefinition;
}();

exports.PropertyTypeDefinition = PropertyTypeDefinition;